
export const apiUrl = "https://api.ribo.ziz.co.ke/api"
export const socketsApiUrl = "wss://api.ribo.ziz.co.ke"
